module["exports"] = ["გამზ.", "გამზირი", "ქ.", "ქუჩა", "ჩიხი", "ხეივანი"];